import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionItem } from './SessionItem';
import { useAgentSessions } from './AgentSessionContext';

const getDateGroup = (dateStr, t) => {
    if (!dateStr) return t('agent_chat.date_older');
    const date = new Date(dateStr);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    if (date >= today) return t('agent_chat.date_today');
    if (date >= yesterday) return t('agent_chat.date_yesterday');
    if (date >= weekAgo) return t('agent_chat.date_this_week');
    if (date >= monthStart) return t('agent_chat.date_this_month');
    return t('agent_chat.date_older');
};

const GROUP_ORDER = ['date_today', 'date_yesterday', 'date_this_week', 'date_this_month', 'date_older'];

export const SessionList = ({ onShare, onArchive, onDelete }) => {
    const { t } = useTranslation();
    const { sessions, isLoading, searchQuery } = useAgentSessions();

    const groupedSessions = useMemo(() => {
        const groups = {};
        sessions.forEach(session => {
            const group = getDateGroup(session.last_message_at || session.created_at, t);
            if (!groups[group]) groups[group] = [];
            groups[group].push(session);
        });

        // Ordenar grupos según GROUP_ORDER
        const ordered = [];
        GROUP_ORDER.forEach(key => {
            const label = t(`agent_chat.${key}`);
            if (groups[label]) {
                ordered.push({ label, sessions: groups[label] });
            }
        });
        return ordered;
    }, [sessions, t]);

    if (isLoading) {
        return (
            <div className="agent-sidebar__sessions">
                <div className="agent-sidebar__loading">
                    <i className="fas fa-spinner fa-spin"></i>
                </div>
            </div>
        );
    }

    if (sessions.length === 0) {
        return (
            <div className="agent-sidebar__sessions">
                <div className="agent-sidebar__empty">
                    {searchQuery
                        ? t('agent_chat.no_sessions_filtered')
                        : t('agent_chat.no_sessions')
                    }
                </div>
            </div>
        );
    }

    return (
        <div className="agent-sidebar__sessions">
            {groupedSessions.map(group => (
                <div key={group.label} className="agent-sidebar__group">
                    <div className="agent-sidebar__group-label">{group.label}</div>
                    {group.sessions.map(session => (
                        <SessionItem
                            key={session.session_id}
                            session={session}
                            onShare={onShare}
                            onArchive={onArchive}
                            onDelete={onDelete}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};
